import { Check, ShieldCheck, Users, Zap } from 'lucide-react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { RolePageData } from '../../types'
import { CROSS_PERSONA_TRUTHS } from '../../consts'

interface SolutionSectionProps {
  data: RolePageData
}

const SOLUTION_ICONS = [ShieldCheck, Users, Zap]

export const SolutionSection = ({ data }: SolutionSectionProps) => {
  return (
    <section className="w-full py-24 bg-gradient-to-b from-white via-stone-50 to-stone-100">
      <Column className="w-full max-w-6xl mx-auto px-8 gap-16">
        {/* Header */}
        <Column className="gap-4 text-center">
          <h2 className="text-3xl font-normal text-slate-800">
            How we make your job easier
          </h2>
          <p className="text-slate-500 text-lg max-w-xl mx-auto">
            Built around what {data.label.toLowerCase()} teams actually need.
          </p>
        </Column>

        {/* Cross-persona truths */}
        <Row className="gap-8 justify-center">
          {CROSS_PERSONA_TRUTHS.messages.map((message, index) => {
            const Icon = SOLUTION_ICONS[index]
            return (
              <Column key={message} className="items-center gap-4 flex-1 max-w-xs">
                <div className="w-14 h-14 rounded-full bg-white/80 backdrop-blur-sm border border-white/60 flex items-center justify-center shadow-sm">
                  <Icon className="w-7 h-7 text-slate-700" strokeWidth={1.5} />
                </div>
                <h3 className="text-slate-700 text-center">
                  {message}
                </h3>
              </Column>
            )
          })}
        </Row>

        {/* What they value */}
        <Column className="gap-6 p-8 bg-white/70 backdrop-blur-sm rounded-2xl border border-white/60">
          <p className="text-sm font-medium text-slate-500 uppercase tracking-wider text-center">
            What matters to you
          </p>
          <Row className="gap-4 justify-center flex-wrap">
            {data.whatTheyValue.map((value) => (
              <Row
                key={value}
                className="items-center gap-2 px-4 py-2 bg-white/80 border border-white/60 rounded-full shadow-sm"
              >
                <Check className="w-4 h-4 text-blue-500" />
                <span className="text-slate-700 text-sm">{value}</span>
              </Row>
            ))}
          </Row>
        </Column>
      </Column>
    </section>
  )
}
